/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Music14Inputs */

const en__field__enum_teachingsubjectinterest_subject_music14 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Music14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Music`)
};

const de__field__enum_teachingsubjectinterest_subject_music14 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Music14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Musik`)
};

/**
* | output |
* | --- |
* | "Music" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Music14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_music14 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Music14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Music14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_music14(inputs)
	return de__field__enum_teachingsubjectinterest_subject_music14(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_music14 as "_field__enum_teachingSubjectInterest_SUBJECT_MUSIC" }